
import { Assets } from "../list/Assets";
import styles from '../../styles/MobileCanvas.module.css';

export default function MobileCanvas(props) {
  return (
    <div className={styles.thumb_canvas_Grid}>
      <div className={styles.child}><img alt={props.name} className={styles.mobile_image} src={props.thumb}></img></div>
      <div className={`${styles.child} ${styles.child1}`}>  <div className={styles.mobile_btns} onClick={props.onClick}>
        <img
        alt="Play Now"
          className={styles.play_btn}
          src={Assets[0].m_play_btn}
        ></img>
        <p className={styles.play_text}>Play Now</p>
      </div></div>
     
    
     
    </div>
  );
}